import React, { CSSProperties } from "react";

export default function IconFloorCurrent(props: {
	className?: string;
	style?: CSSProperties;
	color?: string;
	size?: number;
}) {
	return (
		<svg
			className={props.className}
			style={props.style}
			xmlns="http://www.w3.org/2000/svg"
			width={props.size ?? 24}
			height={props.size ?? 24}
			viewBox="0 0 24 24"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M15 6C15 5.44772 15.4477 5 16 5H20C20.5523 5 21 5.44772 21 6C21 6.55228 20.5523 7 20 7H17V10C17 10.5523 16.5523 11 16 11H13V14C13 14.5523 12.5523 15 12 15H9V18C9 18.5523 8.55228 19 8 19H4C3.44772 19 3 18.5523 3 18C3 17.4477 3.44772 17 4 17H7V14C7 13.4477 7.44772 13 8 13H11V10C11 9.44772 11.4477 9 12 9H15V6Z"
				fill={props.color ?? "black"}
			/>

			<path
				d="M6 3.5C5.60218 3.5 5.22064 3.65804 4.93934 3.93934C4.65804 4.22064 4.5 4.60218 4.5 5C4.5 5.39782 4.65804 5.77936 4.93934 6.06066C5.22064 6.34196 5.60218 6.5 6 6.5C6.39782 6.5 6.77936 6.34196 7.06066 6.06066C7.34196 5.77936 7.5 5.39782 7.5 5C7.5 4.60218 7.34196 4.22064 7.06066 3.93934C6.77936 3.65804 6.39782 3.5 6 3.5ZM6 7.5C5.33696 7.5 4.70107 7.23661 4.23223 6.76777C3.76339 6.29893 3.5 5.66304 3.5 5C3.5 4.33696 3.76339 3.70107 4.23223 3.23223C4.70107 2.76339 5.33696 2.5 6 2.5C6.66304 2.5 7.29893 2.76339 7.76777 3.23223C8.23661 3.70107 8.5 4.33696 8.5 5C8.5 5.66304 8.23661 6.29893 7.76777 6.76777C7.29893 7.23661 6.66304 7.5 6 7.5ZM6 1.25C3.5 1.25 1.365 2.805 0.5 5C1.365 7.195 3.5 8.75 6 8.75C8.5 8.75 10.635 7.195 11.5 5C10.635 2.805 8.5 1.25 6 1.25Z"
				fill={props.color ?? "black"}
			/>
		</svg>
	);
}
